import { useIntl } from "react-intl";

export default function Locale({ code }) {
  const intl = useIntl();
  return intl.formatMessage({ id: code ?? "-" });
}
